const API_BASE = '';

async function apiFetch(url, options = {}) {
  try {
    const res = await fetch(API_BASE + url, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...options.headers },
      ...options,
    });
    if (res.status === 401) {
      window.location.href = '/authentication/sign-in';
      return null;
    }
    const ct = res.headers.get('content-type') || '';
    if (!ct.includes('application/json')) {
      console.error('Non-JSON response from', url);
      window.location.href = '/authentication/sign-in';
      return null;
    }
    return res.json();
  } catch (err) {
    console.error('API error:', err);
    return null;
  }
}

export async function checkAuth() {
  try {
    const res = await fetch('/api/auth-check', { credentials: 'include' });
    return res.ok;
  } catch { return false; }
}

export async function login(username, password) {
  const res = await fetch('/api/login', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  return res;
}

export async function logout() {
  await fetch('/api/logout-json', { credentials: 'include' });
  window.location.href = '/authentication/sign-in';
}

export async function getSummary() {
  return apiFetch('/api/summary?days=90');
}

export async function getExpenses() {
  return apiFetch('/api/expenses?days=90');
}

export async function updateExpense(id, data) {
  return apiFetch(`/api/expense/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

export async function deleteExpense(id) {
  return apiFetch(`/api/expense/${id}`, { method: 'DELETE' });
}

export async function addExpense(data) {
  return apiFetch('/api/expense', { method: 'POST', body: JSON.stringify(data) });
}

export async function getInsights() {
  return apiFetch('/api/insights');
}
